import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class FarfetchSizeMapApiClient extends AdvancedApiClient {

    static entityType = "FarfetchSizeMap"

    constructor(token, sizeId, id) {
        super();

        this.setEntityType(FarfetchSizeMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/size/{sid}/farfetch-map/{id}")
                .setRouteParam("sid", sizeId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/size/{sid}/farfetch-map")
                .setRouteParam("sid", sizeId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}